import { Type } from 'class-transformer';
import { IsInt, IsUUID, IsNotEmpty, IsOptional, Min } from 'class-validator';

import { FilterType } from '@vk-hr-tek/core/filter';

export class GetAttorneysListDto {
  @IsUUID()
  @IsNotEmpty()
  company_id: string;

  @IsOptional()
  @IsInt()
  @Min(0)
  @Type(() => Number)
  offset = 0;

  @IsOptional()
  @IsInt()
  @Min(1)
  @Type(() => Number)
  // eslint-disable-next-line no-magic-numbers
  limit = 20;

  filters: FilterType;
}
